// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
 
	// TEMPORARY FIX: adding /chic/antigua harcoded
	let current_url = document.URL
	if( current_url.indexOf( "resorts/chic-antigua" ) != "-1" ){
		
		let primary_links = document.querySelectorAll( "#privary-navigation a" )
		primary_links.forEach( link => {
			let href = link.href
            
			if( href.indexOf( "black-friday" ) == "-1" && href.indexOf( "our-resort" ) == "-1" && href.indexOf( "royaltonresorts" ) != "-1" && href.indexOf( "resorts/chic-antigua" ) == "-1" ){
                console.log( href, site_url, href.indexOf( site_url )  )
				link.setAttribute( "href", href.replace( ".com/", ".com/resorts/chic-antigua/" )  )
			}
		} )

	}

	$(document).ready(function () {
		$('.header__burger').click(function(e) {
			e.preventDefault();
            $('.burger').toggleClass('open');
		});
		$('.burger__close').click(function(e) {
			e.preventDefault();
            $('.burger').removeClass('open');
		});

		$('.non-clickable').click(function(e) {
			e.preventDefault();
		});
		$('.sub-menu li a').click(function(e) {
			let target = $(this).attr('href');
			if(target.includes('#')) {
				e.preventDefault();
				$('html, body').animate({scrollTop: $(target).offset().top - $('header').height()}, 800);
			}
		});

		$('.burger__show-resorts').click(function(e) {
			e.preventDefault();
			$('.burger__right').toggleClass('hide-resorts');
			$(this).toggleClass('active');
		});

		$("#primary-nav li").each(function( index ) {
			if($(this).children('ul').length > 0) {
				$(this).addClass('has-menu');
			}
		});
		$("#primary-nav li a").each(function( index ) {
			if($(this).hasClass('parent-active')) {
				$(this).parent('li').addClass('open');
			}
		});
		// $("#primary-nav li ul").each(function( index ) {
		// 	if($(this).hasClass('resort')) {
		// 		$(this).wrap('<div class="submenu-wrap first"></div>');
		// 	} else {
		// 		$(this).wrap('<div class="submenu-wrap"></div>');
		// 	}
		// });
		$("#primary-nav li").hover(function(){
            var target = $(this);
            window.mytimeout = setTimeout(function(){
				target.addClass("hover");
                $('.submenu',target).slideDown(300);
            }, 100);
        }, function(){
            if($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $('.submenu',this).slideUp(300);
            } else {
                clearTimeout(window.mytimeout);
            }
        });
		$("#tertiary-navigation").append('<li id="teconsent"></li><li id="ccpacontainer"></li>');

	});

	document.addEventListener('DOMContentLoaded', () => {
		 
		let scrollDownTopContentCTA = document.querySelector(`.scrollDown`);
		scrollDownTopContentCTA.addEventListener("click", (e) => {
			e.preventDefault();
			const topHeight = document.querySelector(`.hero`).getBoundingClientRect().height;
			const heightHeader = document.querySelector(`header`).getBoundingClientRect().height;
			$("html,body").animate({ scrollTop: (topHeight - heightHeader) }, 1200);
		})

	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());
 
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}